import { useTranslation } from 'react-i18next';
import { useEnvironment } from '../utils/environment';

/*
 * Which deployment this is, at the foot of every page -- and only outside
 * production. Production renders nothing at all: no element, no footer row,
 * no space kept for one. Nothing is shown while the answer is unknown or the
 * server could not be asked either, so production never flashes a badge.
 *
 *   variant="footer"    Layout's own footer row, under the page
 *   variant="floating"  the pages outside Layout (sign-in, survey, workspace
 *                       chooser, Field Mode): a small pill fixed at the foot,
 *                       which a tap passes straight through
 */
export const LABELS = { dev: 'DEV', staging: 'STAGING', local: 'DEV · LOCAL' };
const TONES = {
  dev: { background: '#b45309', color: '#fff' },
  local: { background: '#b45309', color: '#fff' },
  staging: { background: '#6d28d9', color: '#fff' },
};

export function badgeFor(environment) {
  return LABELS[environment] ? { label: LABELS[environment], tone: TONES[environment] } : null;
}

export default function EnvironmentBadge({ variant = 'footer', environment }) {
  const { t } = useTranslation('common');
  const known = useEnvironment();
  const badge = badgeFor(environment === undefined ? known : environment);
  if (!badge) return null;
  const floating = variant === 'floating';
  const pill = (
    <span data-testid="environment-badge" data-environment={environment === undefined ? known : environment}
      title={t('environment.tip')}
      style={{ ...badge.tone, display: 'inline-block', padding: floating ? '0 8px' : '2px 10px', borderRadius: 999,
        fontSize: floating ? 10 : 11, fontWeight: 700, letterSpacing: '.06em', lineHeight: floating ? '16px' : '18px',
        whiteSpace: 'nowrap' }}>
      {badge.label}
    </span>
  );
  if (floating) {
    return (
      <div data-testid="environment-badge-floating" aria-hidden="false"
        style={{ position: 'fixed', insetInlineStart: 8, bottom: 'calc(env(safe-area-inset-bottom, 0px) + 2px)',
          zIndex: 2500, pointerEvents: 'none', opacity: 0.9 }}>
        {pill}
      </div>
    );
  }
  return (
    <footer className="pn-footer" data-testid="environment-footer"
      style={{ display: 'flex', justifyContent: 'center', padding: '8px 16px 16px' }}>
      {pill}
    </footer>
  );
}
